import React from "react";

export const ArrowRightIcon = ({
  width = 16,
  height = 16,
  color = "currentColor",
}) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M3 12L21 12M21 12L12.5 3.5M21 12L12.5 20.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
